import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  select: {
    minWidth: '17.5rem',
  },
})

export default useStyles
